/*
    Core store module mutations

*/

import * as temp from './temp'

export default {
  ...temp
}
